import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { BASE_URL } from '../constants';

interface CreatePublicConversationRequest {
	agentTemplateId: string;
	clientIdentifier: string;
	timeZone?: string;
}

export function usePublicAIConversationCreateMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Error) => void;
	onSuccess?: (data: Api.AIConversation) => void;
} = {}) {
	return useMutation({
		mutationFn: async (request: CreatePublicConversationRequest) => {
			const response = await fetch(`${BASE_URL}/public/aiConversation`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(request),
			});
			const data: Api.IOperationResult<Api.AIConversation> = await response.json();
			if (!data.success) {
				throw new Error(data.systemMessage);
			}
			return data.value;
		},
		onError,
		onSuccess,
	});
}
